import icomplyLogo from "../../../../../assets/images/icomply.png";


export default function YesNoPDFGenerator(schema,formState,extra=[]){

    // console.log(schema);

    // console.log(formState)

    let html = `
        <div class="template-container">
            <style>
                .template-container {
                    background-color: #fff ;
                    margin : 1rem ;
                    padding: 1rem ;
                    font-family: sans-serif ;
                    border-radius: 8px ;
                    border : 1px solid #eee ;
                }

                .template-icomply-brand {
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    padding: 2rem 0;
                }

                .template-icomply-brand img {
                    height : 3rem ;
                }

                .template-self-declaration {
                    background-color: #fff ;
                    padding: 1rem ;
                    font-family: sans-serif ;
                    border-radius: 8px ;
                    border : 1px solid #eee ;
                    margin-top:1.5rem;
                }

                .template-self-declaration h3{
                    line-height:1;
                }

                .template-self-declaration p {
                    font-size : 14px ;
                }
                
                .template-container .template-name {
                    font-size: 1.25rem ;
                    font-weight: 700 ;
                    line-height:2;
                }
                
                .template-container .template-field {
                    flex: 1 ;
                    display: flex ;
                }

                .template-container .template-field + .template-field {
                    margin-top:0.75rem;
                }

                .template-container .template-link {
                    text-align:left;
                }

                .template-section-title {
                    line-height:2.5;
                }

                .template-tnc {
                    display: flex ;
                    align-items:center;
                }
                
                .template-container .template-field .template-key ,
                .template-container .template-link .template-key {
                    font-weight: 700 ;
                    margin-right: 0.5rem ;
                }
                
                .template-container .template-field .template-value ,
                .template-container .template-link .template-value {
                    color: #444;
                }

                .template-container .template-q .template-key {
                    flex : 1 0 95% ;
                }

                .template-container .template-q .template-value {
                    flex : 1 0 5% ;
                }

                .template-container .template-longtext {
                    display:block;
                }
                
            </style>

            <div class="template-icomply-brand">
                <img src="${icomplyLogo}" />
            </div>

            <div class="template-name">${formState.formTitle}</div>

            ${
                extra.filter(f => f.position === "top").map(ff => (`
                    <div class="template-field" style="margin-top:1.5rem;">
                        <div class="template-key">${ff.field}</div>
                        <div class="template-value">${ff.value}</div>
                    </div>
                `)).join("") || ""
            }

            ${
                Object.keys(schema).map(key => (`
                    <h3 class="template-section-title">${key}</h3>
                    ${
                        schema[key].map(field => {
                            if(field?.type === "text" ) {
                                return (`
                                    <div class="template-field">
                                        <div class="template-key">${field.question}</div>
                                        <div class="template-value">${formState[field.id]|| "-"}</div>
                                    </div>
                                `)
                            } else if (field?.type === "longtext"){
                                return (`
                                    <div class="template-field template-longtext">
                                        <div class="template-key">${field.question}</div>
                                        <div class="template-value">${formState[field.id] || "-"}</div>
                                    </div>
                                `)
                            } else {
                                return (`
                                    <div class="template-field template-q">
                                        <div class="template-key">${field.question}</div>
                                        <div class="template-value">${formState[field.id] === "true" ? "YES" : "NO" }</div>
                                    </div>
                                `)
                            }
                        }).join("")
                    }
                    
                `)).join("")
            }

            ${
                extra.filter(f => f.position === "bottom").map(ff => (`
                    <div class="template-field" style="margin-top:1.5rem;">
                        <div class="template-key">${ff.field}</div>
                        <div class="template-value">${ff.value}</div>
                    </div>
                `)).join("") || ""
            }

            <div class="template-self-declaration">
                <h3>Self Declaration</h3>
                <p>
                    You are about to declare that you have met requirements under the Property & Stock Agents Act 2002. This declaration will be used to demonstrate compliance and may be subject to audit review by Fair Trading
                </p>
                <div class="template-tnc">
                    <input type="checkbox" checked="${formState.tncAgreed}" />
                    <span style="margin-left:0.25rem"> I agree to the Terms of Service</span>
                </div>
                <div class="template-field">
                    <div class="template-key">Name Of Person Completing Form</div>
                    <div class="template-value">${formState.nameOfPersonCompletingForm}</div>
                </div>
                <div class="template-field">
                    <div class="template-key">Date</div>
                    <div class="template-value">${formState.dateOfFormCompletionInString}</div>
                </div>
            </div>
        </div>
    `;

    return html ;
}
